import { Ammo, physicsWorld } from '../physics'
import state from '../state'
import * as THREE from 'three'
import { createParalellepiped } from './utils'

export default function createBase({ ball, pos, quat, ropePos }) {
  const armMass = 2
  const armLength = 3
  const pylonHeight = ropePos.y * 2
  const baseMaterial = new THREE.MeshPhongMaterial({ color: 0x606060 })

  pos.set(ropePos.x, 0.1, ropePos.z - armLength)
  quat.set(0, 0, 0, 1)

  const base = createParalellepiped(1, 0.2, 1, 0, pos, quat, baseMaterial)
  base.castShadow = true
  base.receiveShadow = true
  pos.set(ropePos.x, 0.5 * pylonHeight, ropePos.z - armLength)

  const pylon = createParalellepiped(
    0.4,
    pylonHeight,
    0.4,
    0,
    pos,
    quat,
    baseMaterial,
  )
  pylon.castShadow = true
  pylon.receiveShadow = true
  pylon.rotation.set(pylon.rotation.x, Math.PI / 2, pylon.rotation.z)

  pos.set(ropePos.x, pylonHeight + 0.2, ropePos.z - 0.5 * armLength)

  const arm = createParalellepiped(
    0.4,
    0.4,
    armLength + 0.4,
    armMass,
    pos,
    //new THREE.Vector3(pos.x, pos.y, pos.z),
    quat,
    baseMaterial,
  )
  arm.castShadow = true
  arm.receiveShadow = true

  // Arm hinge
  const pivotA = new Ammo.btVector3(0, pylonHeight * 0.5, 0)
  const pivotB = new Ammo.btVector3(0, -0.2, -armLength * 0.5)
  const axis = new Ammo.btVector3(0, 1, 0) // set X to 0 for vertical spin
  const hinge = new Ammo.btHingeConstraint(
    pylon.userData.physicsBody,
    arm.userData.physicsBody,
    pivotA,
    pivotB,
    axis,
    axis,
    true,
  )

  physicsWorld.addConstraint(hinge, true)

  return { arm, base, hinge, pylon }
}
